import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { catalogEntityCreatePermission } from '@backstage/plugin-catalog-common/alpha';

const groupsPage = PageBlueprint.make({
  name: 'groups',
  params: {
    path: '/groups',
    title: 'Teams',
    loader: () =>
      import('../../components/GroupsIndex/GroupIndexPage').then(m => <m.GroupIndexPage />),
  },
});

const appIdResolverPage = PageBlueprint.make({
  name: 'app-id-resolver',
  params: {
    path: '/catalog/by-app-id/:appId',
    title: 'Catalog',
    loader: () =>
      import('../../components/catalog/AppIdResolver/AppIdResolverPage').then(m => (
        <m.AppIdResolverPage />
      )),
  },
});

const apiExplorerPage = PageBlueprint.make({
  name: 'api-explorer',
  params: {
    path: '/api-docs',
    title: 'APIs',
    loader: () =>
      import('../../components/ApiExplorerPage/ApiExplorerPage').then(m => <m.ApiExplorerPage />),
  },
});

const customImportPage = PageBlueprint.make({
  name: 'custom-import',
  params: {
    path: '/catalog-import/custom',
    title: 'Import',
    loader: () =>
      import('../../components/catalog/CustomImportPage').then(m => (
        <RequirePermission permission={catalogEntityCreatePermission}>
          <m.CustomImportPage />
        </RequirePermission>
      )),
  },
});

export const customPagesModule = createFrontendModule({
  pluginId: 'app',
  extensions: [groupsPage, appIdResolverPage, apiExplorerPage, customImportPage],
});
